let modalPool = {}

export const getModalPool = () => modalPool

export const register = components => {
  modalPool = components
}
